import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { showAccessDeniedAlert } from "../../../utils/accessDenied"
import RoutesMap from "../../../route_control/RouteControl"
import axios from "axios"

export const eventDetails = createAsyncThunk('eventDetails', async ({ id, navigate }) => {

    const participant = JSON.parse(localStorage.getItem('user_details'))

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `event_data/${id}`,
            params: {
                'participant_code': participant?.participant_code,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const eventDetailsSlice = createSlice({
    name: 'eventDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(eventDetails.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                localStorage.clear()
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(eventDetails.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default eventDetailsSlice.reducer; 